import { Controller } from "@hotwired/stimulus"

// Варианты подтекста в форме шаблона: клик по варианту кладёт его в поле.
export default class extends Controller {
  static targets = ["field"]

  pick(event) {
    event.preventDefault()
    this.fieldTarget.value = event.currentTarget.dataset.text
  }
}
